var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"users"}},[_c('div',{staticClass:"col-12"},[_c('vuetify-table',{attrs:{"headers":_vm.headers,"apiURL":_vm.apiURL,"readonly":true,"title":"Documentos Permitidos"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }